export const zhCN = {
  seo: {
    title: 'StellarTrail / 寻径星野｜出发前的户外准备助手',
    description: '寻径星野帮助你在出发前管理个人装备、确认打包清单、梳理行程准备，并复习关键绳结技能。'
  },
  nav: {
    product: '产品介绍',
    gear: '个人装备',
    packing: '装备清单',
    trips: '行程准备',
    skills: '绳结技能',
    entry: '下载入口',
    web: 'Web端',
    downloads: '下载',
    docs: '接口文档',
    privacy: '隐私政策',
    language: '语言'
  },
  jump: {
    label: '页面快捷跳转',
    trigger: '展开页面快捷跳转',
    title: '本页跳转',
    home: '首页'
  },
  hero: {
    eyebrow: 'StellarTrail / 寻径星野',
    title: '出发前，把装备、清单、行程和绳结都准备好',
    subtitle: '面向户外准备阶段的轻量助手：记录个人装备，逐项确认打包清单，梳理行程准备，并在出发前复习真正用得上的绳结技能。',
    primaryCta: '查看下载入口',
    secondaryCta: '打开 Web 端',
    stats: [
      { value: '整理', label: '装备与清单' },
      { value: '确认', label: '行程准备' },
      { value: '复习', label: '绳结技能' }
    ]
  },
  product: {
    eyebrow: '产品定位',
    title: '把分散的出发前准备，整理成可检查的步骤',
    body: '寻径星野聚焦出发前的准备环节。官网优先展示已经能在产品中看到的重点能力，并用清楚的状态标签区分可用入口与功能预览。',
    statusLabels: {
      available: '当前可用',
      preview: '功能预览'
    },
    capabilities: {
      gear: {
        title: '个人装备',
        subtitle: '记录每件装备的分类、状态、重量、价值和存放信息。',
        body: '适合把头灯、背包、炉具等常用装备沉淀成自己的清单，出发前可以按分类快速检查。',
        bullets: ['装备数量和重量统计', '分类、状态与搜索筛选', '装备详情与编辑管理']
      },
      packing: {
        title: '装备清单',
        subtitle: '按行程和场景逐项确认出发物品。',
        body: '把个人装备转成打包清单，重点查看总重量、已打包重量和遗漏项，减少出发前反复翻找。',
        bullets: ['按场景建立清单', '逐项勾选已打包物品', '查看总重量和完成度']
      },
      trips: {
        title: '行程准备',
        subtitle: '把单人准备和多人协作放到同一个视图里。',
        body: '行程页用于整理出发时间、成员协作和准备进度，帮助你在出发前确认装备、技能、天气和安全预案。',
        bullets: ['单人准备与多人协作', '成员和天数概览', '准备进度提示']
      },
      skills: {
        title: '绳结技能',
        subtitle: '出发前复习可立即上手的户外技能。',
        body: '当前技能库聚焦绳结，适合快速查看常用露营、钓鱼、连接和固定绳结，并在需要时进入详情练习。',
        bullets: ['绳结分类入口', '收藏清单', '适合出发前快速复习']
      }
    }
  },
  gear: {
    eyebrow: '个人装备',
    title: '把每件装备都放进可追踪的个人装备库',
    body: '记录装备分类、状态、重量和价值。无论是在桌面整理，还是手机上出发前检查，都能快速确认当前可用装备。',
    bullets: ['查看装备数量、分类数、总重量和估值', '按名称、品牌、型号搜索', '从个人装备进入图鉴或打包清单']
  },
  packing: {
    eyebrow: '装备清单',
    title: '出发前逐项确认该带的物品',
    body: '打包清单把准备工作拆成可勾选条目，适合按目的地、天数和场景确认装备，减少临出门前的遗漏。',
    bullets: ['按行程建立打包清单', '查看总重量和已打包重量', '把清单状态保持在手机上']
  },
  trips: {
    eyebrow: '行程准备',
    title: '让行程信息、成员协作和准备进度更清楚',
    body: '行程准备页把时间、成员和准备度集中展示，适合出发前快速确认还有哪些事项需要补齐。',
    bullets: ['单人准备与多人协作入口', '查看日期、成员和天数', '出发前检查装备、技能、天气和安全预案']
  },
  skills: {
    eyebrow: '绳结技能',
    title: '从绳结开始，复习真正用得上的户外技能',
    body: '当前技能库聚焦绳结，覆盖露营、钓鱼、连接和固定等常见场景，适合出发前快速复习。',
    bullets: ['当前能力：绳结教程', '收藏常用技能', '适合出发前快速复习']
  },
  screenshots: {
    androidGearAlt: 'Android 端个人装备界面',
    androidPackingAlt: 'Android 端打包清单界面',
    androidTripsAlt: 'Android 端行程准备界面',
    androidSkillsAlt: 'Android 端绳结技能界面',
    wechatGearAlt: '微信小程序端装备管理界面',
    wechatKnotsAlt: '微信小程序端绳结技能界面',
    webGearAlt: 'Web 端装备管理界面',
    webGearFormAlt: 'Web 端添加装备表单界面'
  },
  entry: {
    eyebrow: '下载入口',
    title: '移动端入口集中在下载页',
    body: 'Web 端已上线，可以直接在浏览器整理个人装备和查看公开内容；Android 安装方式和微信小程序入口都统一放在下载页。',
    badge: 'Multi-platform',
    hint: '首页不放占位下载地址或占位小程序码；移动端入口准备好后在下载页更新。',
    channelsLabel: '支持平台入口',
    channels: [
      {
        title: 'Web 访问',
        body: 'Web 端已上线，适合在桌面大屏整理装备与查看公开内容。',
        href: 'https://app.stellartrail.cn/',
        action: '打开 Web 端',
        external: true
      },
      {
        title: '移动端下载页',
        body: 'Android 安装与微信小程序入口集中在一个页面查看。',
        href: 'downloads/',
        action: '查看下载页',
        external: false
      }
    ]
  },
  downloads: {
    seo: {
      title: 'StellarTrail / 寻径星野｜下载与移动端入口',
      description: '查看寻径星野 Web、Android 与微信小程序入口状态，移动端下载入口集中在本页。'
    },
    nav: {
      label: '下载页导航',
      brand: 'StellarTrail / 寻径星野',
      backHome: '返回官网',
      web: 'Web端',
      docs: '接口文档',
      privacy: '隐私政策'
    },
    hero: {
      eyebrow: '下载入口',
      title: '移动端入口都放在这里',
      body: 'Android 安装方式和微信小程序入口会集中在本页更新。当前 Web 端可直接打开，未公开的移动端入口会保持明确的准备中状态。',
      primaryCta: '查看移动端入口',
      secondaryCta: '打开 Web 端'
    },
    summary: {
      title: '入口状态',
      items: ['Web 端当前可用', 'Android 安装入口准备中', '微信小程序入口准备中']
    },
    channelsLabel: '下载与入口列表',
    channels: {
      android: {
        platform: 'Android',
        status: '准备中',
        title: 'Android 安装包',
        body: 'Android 端已有产品界面示例。安装包、应用市场或其他公开安装方式准备好后，会在这里提供。',
        bullets: ['集中展示安装状态', '不放占位下载地址', '公开后更新真实入口'],
        action: '暂未开放下载',
        note: '准备好后会在本页更新 Android 入口。'
      },
      wechat: {
        platform: '微信小程序',
        status: '准备中',
        title: '微信小程序入口',
        body: '适合在微信内快速打开查看装备与绳结内容。小程序码准备好后，会在这里展示。',
        bullets: ['集中展示小程序状态', '不放占位小程序码', '公开后更新真实入口'],
        action: '暂未开放',
        note: '准备好后会在本页更新微信小程序入口。'
      },
      web: {
        platform: 'Web',
        status: '当前可用',
        title: 'Web 端',
        body: 'Web 端已经可以打开，适合先在浏览器整理装备与查看公开内容。',
        bullets: ['桌面大屏整理装备', '浏览公开内容', '无需安装'],
        action: '打开 Web 端',
        note: '移动端入口公开前，可以先使用 Web 端。'
      }
    },
    footerNote: '不会展示假下载地址或假小程序码；未公开入口会明确标注状态。'
  },
  privacy: {
    seo: {
      title: 'StellarTrail / 寻径星野｜隐私政策',
      description: '查看寻径星野/StellarTrail 如何收集、使用、保存和保护个人信息，以及如何删除账号。'
    },
    nav: {
      label: '隐私政策导航',
      brand: 'StellarTrail / 寻径星野',
      backHome: '返回官网',
      downloads: '下载',
      docs: '接口文档'
    },
    hero: {
      eyebrow: 'Privacy',
      title: '隐私政策',
      body: '本政策说明寻径星野/StellarTrail 在提供账号、装备管理、打包清单、行程准备、轨迹、绳结技能和反馈等服务时，如何处理与你有关的信息。'
    },
    meta: {
      label: '政策信息',
      operator: '运营者',
      operatorName: '寻径星野/StellarTrail',
      effectiveDate: '生效日期',
      effectiveDateValue: '2026-06-15',
      contact: '隐私联系邮箱',
      contactEmail: 'abuse@stellartrail.cn'
    },
    summary: {
      title: '重点说明',
      items: ['我们只围绕账号、同步、产品功能、安全风控、客户支持和合规需要处理个人信息。', '我们不出售个人信息，也不会把个人信息用于第三方广告画像。', '我们支持删除账号；你可以在应用内发起删除，也可以通过 abuse@stellartrail.cn 联系处理。']
    },
    sections: [
      {
        id: 'scope',
        title: '一、本政策适用范围',
        paragraphs: ['本政策适用于寻径星野/StellarTrail 的官网、Web 端、Android 端、iOS 端、macOS 端和微信小程序等产品入口。不同平台的功能开放进度可能不同，实际处理的信息以你使用的功能为准。']
      },
      {
        id: 'data',
        title: '二、我们可能处理的信息',
        paragraphs: ['为了提供账号登录、数据同步、户外准备和客户支持能力，我们可能处理以下类型的信息：'],
        bullets: ['账号与登录信息：用户名、昵称、邮箱、手机号、微信登录标识、验证码校验结果、访问令牌哈希和登录状态；使用账号密码登录时，用户密码会在服务端进行 SHA-256 Hash 后入库，不保存明文密码。', '个人资料与户外资料：头像、真实姓名、性别、出生日期、身高、联系方式、紧急联系人、血型、病史、过敏史、饮食偏好、保险信息和户外经历备注等你主动填写的内容。', '产品内容数据：个人装备、装备重量与价格、存放位置、打包清单、行程准备、成员协作、轨迹文件、地图标注、绳结收藏、产品计划投票或订阅等内容。', '上传与反馈数据：头像图片、反馈图片、反馈文字、联系方式、页面路径、客户端平台、客户端版本和设备型号。', '权限与设备相关数据：Android 端可能在你授权后使用粗略或精确位置，用于地图、轨迹或当前位置相关能力；导入 GPX/KML/KMZ/FIT 等文件时会读取你主动选择或分享给应用的文件内容。', '安全和统计数据：为保护服务安全和了解接口运行情况，我们会记录经过最小化处理的 API 使用聚合统计，例如认证用户 ID、HTTP 方法、路由模板、状态码、日期桶和调用次数；不记录请求体、响应体、Token、Cookie、IP 或 User-Agent。']
      },
      {
        id: 'use',
        title: '三、我们如何使用信息',
        paragraphs: ['我们会将上述信息用于以下目的：'],
        bullets: ['创建和维护账号，完成登录、验证码校验、找回密码、邮箱或手机号绑定。', '同步并展示你的装备、打包清单、行程、轨迹、绳结收藏和其他户外准备内容。', '处理头像、反馈图片和反馈内容，定位问题并回复你的支持请求。', '维护服务安全、识别异常登录、防止滥用、排查故障并满足审计或法律合规要求。', '在不直接识别个人的前提下进行聚合统计，帮助我们了解功能使用情况和服务稳定性。']
      },
      {
        id: 'sharing',
        title: '四、信息共享和委托处理',
        paragraphs: ['我们不出售个人信息。为提供服务，我们可能在必要范围内使用以下服务或向以下对象提供必要信息：'],
        bullets: ['云服务器、数据库、对象存储、CDN 等基础设施，用于保存账号数据、图片、轨迹文件和公开内容媒体。', '邮件和短信服务商，用于发送注册、登录、绑定或找回密码验证码。', '微信开放能力，用于完成微信小程序登录和账号识别。', '应用商店、审核平台或合规机构，用于应用发布、审核、争议处理和安全合规。', '法律法规、监管要求、司法或行政机关依法要求提供的必要信息。']
      },
      {
        id: 'security',
        title: '五、保存和安全保护',
        paragraphs: ['我们会采取合理的技术和管理措施保护个人信息，例如访问控制、传输加密、密码 SHA-256 Hash 入库、令牌哈希保存、图片类型校验、上传配额和日志最小化。我们只会在实现本政策所述目的所需期间保存信息；当信息不再需要，或你依法要求删除且没有必要保留理由时，我们会删除或匿名化处理。']
      },
      {
        id: 'delete-account',
        title: '六、访问、更正和删除账号',
        paragraphs: ['寻径星野/StellarTrail 支持删除账号。你可以在应用内发起账号删除；如果暂时无法使用应用内入口，也可以通过 abuse@stellartrail.cn 联系我们处理账号和相关个人数据删除请求。', '你还可以通过同一邮箱申请访问、更正、补充、删除个人信息，撤回授权，或咨询隐私相关问题。为保护账号安全，我们可能需要验证你的账号身份后再处理请求。']
      },
      {
        id: 'children',
        title: '七、未成年人保护',
        paragraphs: ['寻径星野/StellarTrail 面向具有户外活动判断能力的用户。若你未满 14 周岁，请在监护人同意和指导下使用；监护人如发现未成年人信息被不当提交，可通过 abuse@stellartrail.cn 联系我们处理。']
      },
      {
        id: 'updates',
        title: '八、政策更新和联系我们',
        paragraphs: ['我们可能根据产品功能、法律法规或运营情况更新本政策。重大变更会通过官网或产品内适当方式提示。隐私问题、投诉、账号删除或个人信息权利请求，请发送邮件至 abuse@stellartrail.cn。']
      }
    ]
  },
  docs: {
    seo: {
      title: 'StellarTrail 开发文档｜API Reference',
      description: 'StellarTrail 服务接口的静态参考文档，按当前后端源码列出已注册的请求路径、请求体、响应体和错误结构。'
    },
    nav: {
      label: '开发文档导航',
      brand: 'StellarTrail Docs',
      backHome: '返回官网'
    },
    hero: {
      eyebrow: '开发文档',
      title: '开发文档',
      body: '这里基于当前后端源码整理已注册的服务接口。示例只使用路径和占位值，不在页面中展示生产访问地址。'
    },
    toc: {
      label: '文档目录'
    },
    source: {
      title: '来源信息',
      repository: '来源仓库',
      inspectedHead: '检查版本',
      inspectedAt: '检查日期',
      endpointCount: '接口数量'
    },
    sections: {
      overview: {
        title: '概览',
        body: '本文档从后端源码中的 Axum 注册表、请求 DTO、响应 DTO 和统一错误模型同步而来，覆盖系统状态、登录账号、公开内容、绳结技能、装备库、上传与反馈。',
        count: '当前列出 {count} 个已注册接口。',
        note: '页面加载时不会请求服务；只有你填写服务地址并点击发送请求时才会发起请求。'
      },
      authentication: {
        title: '认证',
        body: '公开接口不需要登录；用户私有数据接口使用 Authorization Bearer；管理员接口在 Bearer 登录基础上校验管理员权限。技能内容可通过 X-StellarTrail-Locale 或 Accept-Language 选择 zh-CN / en。'
      },
      endpoints: {
        title: '接口',
        body: '下面按功能分组展示当前源码中已注册的请求路径。'
      },
      errors: {
        title: '错误响应',
        body: '服务错误使用统一 JSON 结构：code、message，并按场景附带 fields、captcha 或 parameter。'
      },
      config: {
        title: '访问配置',
        body: '生产访问地址保存在部署侧或本地忽略配置中，不写入公开源码、页面内容或构建产物。调用示例应使用自己的环境变量拼接路径。'
      }
    },
    groupTitles: {
      system: '系统状态',
      auth: '登录与账号',
      content: '公开内容',
      skills: '绳结技能',
      admin: '管理员内容',
      gear: '装备库',
      uploads: '图片上传',
      feedback: '用户反馈'
    },
    authLabels: {
      public: '公开',
      bearer: '需要 Bearer 登录',
      admin: '需要管理员权限'
    },
    endpointSummaries: {
      healthz: '服务状态',
      meta: '服务信息',
      authWechatLogin: '微信小程序登录',
      authEmailVerificationCode: '发送注册邮箱验证码',
      authEmailLoginCode: '发送邮箱登录验证码',
      authEmailLogin: '邮箱验证码登录',
      authPasswordResetCode: '发送重置密码验证码',
      authPasswordReset: '重置密码',
      authRegister: '注册账号',
      authPasswordLogin: '账号密码登录',
      authRefresh: '刷新登录态',
      authCaptcha: '创建图形验证码',
      gearTemplatesList: '装备准备模板列表',
      gearTemplatesDetail: '装备准备模板详情',
      skillsCategories: '户外技能分类',
      skillsKnotsList: '绳结列表',
      skillsKnotsDetail: '绳结详情',
      adminKnotMediaUpload: '上传绳结媒体素材',
      gearsCategories: '我的装备分类统计',
      gearsStats: '我的装备统计',
      gearsExport: '导出装备 CSV',
      gearsImport: '导入装备 JSON',
      gearsList: '我的装备列表',
      gearsCreate: '新增装备',
      gearsDetail: '装备详情',
      gearsUpdate: '更新装备',
      gearsArchive: '归档装备',
      gearsRestore: '恢复装备',
      uploadsCreate: '上传反馈图片',
      uploadsDownload: '读取已上传图片',
      feedbackCreate: '提交反馈'
    },
    labels: {
      group: '分组',
      auth: '权限',
      responseStatus: '响应状态',
      contentType: '请求类型',
      responseType: '响应类型',
      query: '查询参数',
      headers: '请求头',
      requestBody: '请求体',
      responseBody: '响应体',
      noBody: '无响应体',
      tryRequest: '调试请求',
      tryRequestNote: '使用上方统一服务地址；点击发送后才会发起请求，页面不会保存地址、请求头或响应。',
      serviceOrigin: '统一服务地址',
      serviceOriginPlaceholder: 'https://your-api.example.com',
      serviceOriginHelp: '输入一次即可供下方所有接口共用；页面不会保存这个地址。',
      pathParams: '路径参数',
      pathParamLabel: '{name} 路径参数',
      queryParams: '查询参数输入',
      queryParamLabel: '{name} 查询参数',
      extraQuery: '附加查询参数',
      extraQueryPlaceholder: 'foo=bar&limit=20',
      headersInput: '请求头输入',
      headersPlaceholder: 'Authorization: Bearer ...\nX-StellarTrail-Locale: zh-CN',
      requestBodyInput: '请求体输入',
      fileInput: '文件',
      sendRequest: '发送请求',
      sending: '发送中…',
      requestUrl: '请求地址',
      response: '响应',
      responseHeaders: '响应头',
      responseBodyResult: '响应内容',
      fillServiceOrigin: '请先填写服务地址',
      invalidServiceOrigin: '服务地址必须是 http(s) URL，且不能包含查询串或片段。',
      fillPathParam: '请填写 {name} 路径参数',
      invalidHeader: '请求头格式应为 Name: value',
      invalidJson: '请求体必须是合法 JSON',
      networkError: '请求失败：{message}',
      noResponseBody: '无响应内容',
      serviceSettingsTitle: '统一服务地址',
      serviceSettingsNote: '在这里填写一次服务地址，下方所有接口调试都会共用它。留空时不会发送请求。'
    }
  },
  footer: {
    tagline: 'StellarTrail / 寻径星野',
    caption: '户外准备，从清单和绳结开始',
    rights: '保留所有权利。',
    privacyPolicy: '隐私政策'
  },
  language: {
    current: '中文',
    switchTo: 'Switch to English'
  }
} as const;
